import * as Yup from "yup";

export const form = {
  formId: "new-uom-form",
  formField: {
    uomid: {
      name: "uomid",
      label: "UOM ID",
      type: "text",
      errorMsg: "UOM ID is required.",
      required:true,
      //disabled:true,
      edit:true,
      maxLength:10
    },
    descriptions1: {
      name: "descriptions1",
      label: "Descriptions 1",
      type: "text",
      errorMsg: "Descriptions 1 is required.",
      required:true,
      maxLength:100
    },
    descriptions2: {
      name: "descriptions2",
      label: "Descriptions 2",
      type: "text",
    },
    uomType: {
      name: "uomType",
      label: "UOM Type",
      type: "select",//
      errorMsg: "UOM type is required.",
      required:true
    },
  },
};

const formField= {
  uomid: {
    name: "uomid",
    label: "UOM ID",
    type: "text",
    errorMsg: "UOM ID is required.",
    required:true,
    editable:false,
    maxLength:10
  },
  descriptions1: {
    name: "descriptions1",
    label: "Descriptions 1",
    type: "text",
    errorMsg: "Descriptions 1 is required.",
    required:true,
    maxLength:100
  },
  descriptions2: {
    name: "descriptions2",
    label: "Descriptions 2",
    type: "text",
  },
  uomType: {
    name: "uomType",
    label: "UOM Type",
    type: "select",//
    errorMsg: "UOM type is required.",
    required:true
  },
}

const  { uomid, descriptions1, descriptions2, uomType } = formField;

export const formRender=[
  [uomid],[descriptions1],[descriptions2],[uomType]
]

export const initialValues = {
  [uomid.name]: null,
  [descriptions1.name]: null,
  [descriptions2.name]: null,
  [uomType.name]: null,
};

export const uomValidations = Yup.object().shape({
  [uomid.name]: Yup.string().nullable().max(10).required(uomid.errorMsg),
  [descriptions1.name]: Yup.string().nullable().max(100).required(descriptions1.errorMsg),
  [descriptions2.name]: Yup.string().nullable().max(100),
  [uomType.name]: Yup.string().nullable().required(uomType.errorMsg),
})